import * as Yup from "yup";

export const FormValidations = Yup.object().shape({
  amount: Yup.string().required("Amount is required"),
  from_currency: Yup.string().required("This field is required"),
  to_currency: Yup.string().required("This field is required"),
});
